<template>
  <dashboard-card class="db-gloss-reason" title="Glosas por motivo" cut="Top 5">
    <div class="loading loading-lg db-card-loading" v-if="loading"></div>

    <dashboard-empty
      v-else-if="rows.length === 0"
      icon="check-circle"
      title="Nenhuma glosa no período"
      reason="A operadora não glosou nenhum item dos lotes analisados, ou os demonstrativos ainda
              não foram importados."
      action-to="/financial/billing-glosses"
      action-label="Ir para Glosas e recursos"
      action-icon="gavel"
    />

    <div class="db-list" v-else>
      <router-link class="db-list-row db-list-link" v-for="row in rows" :key="row.key"
                   :to="row.to">
        <div>
          <div class="db-list-name" :title="row.description">
            <span class="db-code" v-if="row.code">{{ row.code }}</span>{{ row.description }}
          </div>
          <div class="db-list-sub">{{ row.countLabel }}</div>
        </div>
        <div>
          <div class="db-list-value db-error-text">{{ row.value | currency }}</div>
          <div class="db-list-percent">{{ row.percentLabel }} das glosas</div>
        </div>
        <div class="db-bar" :class="{'db-bar-strong': row.leader}">
          <span :style="{ width: row.width }"></span>
        </div>
      </router-link>
    </div>
  </dashboard-card>
</template>

<script>
import { formatPercent, glossReasonRoute, pluralize } from '../helpers';
import DashboardCard from './DashboardCard.vue';
import DashboardEmpty from './DashboardEmpty.vue';

const TOP = 5;

export default {
  components: {
    DashboardCard,
    DashboardEmpty,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    top() {
      return this.items.slice(0, TOP);
    },
    biggest() {
      return this.top.reduce((max, item) => Math.max(max, item.value), 0);
    },
    rows() {
      return this.top.map((item, index) => ({
        ...item,
        key: item.code || `reason-${index}`,
        leader: index === 0,
        countLabel: pluralize(item.count, 'item glosado', 'itens glosados'),
        percentLabel: formatPercent(item.percent),
        width: this.width(item.value),
        to: glossReasonRoute(item, this.filter),
      }));
    },
  },
  methods: {
    width(value) {
      if (this.biggest <= 0) return '0%';
      return `${Math.max((value / this.biggest) * 100, 2)}%`;
    },
  },
};
</script>
